import React from 'react';
import classNames from 'classnames';

import './styles.css';

interface IconButtonProps {
  src: string;
  alt: string;
  active?: boolean;
  srcActive?: string;
  activeBlue?: boolean;
  onClick?: React.MouseEventHandler;
}

const IconButton: React.FC<IconButtonProps> = ({
  src,
  alt,
  active = false,
  activeBlue = false,
  srcActive = '',
  onClick = () => {}
}) => {
  return (
    <div
      className={classNames('IconButton', {
        'IconButton--active': activeBlue && active
      })}
      onClick={onClick}>
      <div className="IconButton__container colab-centered colab-clickable active">
        {!active && <img src={src} alt={alt} />}
        {active && <img src={srcActive} alt={alt} />}
      </div>
    </div>
  );
};

export default IconButton;
